import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
import language_id from "./translations/id/language.json";
import language_en from "./translations/en/language.json";
import secureStorage from "./config/encrypt";
import { ApolloClient, InMemoryCache, ApolloProvider, from } from '@apollo/client';
import {setContext} from '@apollo/client/link/context';
// import { BrowserRouter } from "react-router-dom";

import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./store/store";  
import {API_URL} from './config/constant';
import { decryptLink, encryptLink, errorLink, httpLink } from "./config/apollo";

i18next.init({
	interpolation: { escapeValue: false },
	lng: secureStorage.getItem("lang") === "id" ? "id" : "en",
	//lng: "en",
	resources: {
		en: {
			common: language_en,
		},
		id: {
			common: language_id,
		},
	},
});

const defaultOptions = {
	watchQuery: {
		fetchPolicy: 'no-cache',
		errorPolicy: 'ignore',
	},
	query: {
		fetchPolicy: 'no-cache',
		errorPolicy: 'all',
	},
}

const authLink = setContext((_, { headers }) => {
	const user_info = JSON.parse(localStorage.getItem('user_information'));
	const token = user_info?.access_token;
	 const user_data = user_info?.user_data;
	 const isUserDataSet = localStorage.getItem('isUserDataSet') || false;
	let headers2send = Object.assign({api_source:'incentive'},headers);
	if(token) {
		headers2send.Authorization = `Bearer ${token}`;
		if(!isUserDataSet && user_data){
			headers2send.user_data = JSON.stringify(user_data);
			localStorage.setItem('isUserDataSet',true);
		}
	}else{
		headers2send.apikey = API_URL.API_KEY;
	}
	return {
	  headers: headers2send
	}
  });

const client = new ApolloClient({
	link: from([errorLink, encryptLink, authLink, decryptLink, httpLink]),
	cache: new InMemoryCache(),
	defaultOptions: defaultOptions
  });

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
	
	<Provider store={store}>
		<ApolloProvider client={client}>
			<I18nextProvider i18n={i18next}>
				<App />
			</I18nextProvider>
		</ApolloProvider>
	</Provider>

);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();